<template>
  <div class="trust">
    <el-dialog
      class="dialog"
      :visible.sync="dialogVisible"
      :width="isMobile"
      :close-on-click-modal='false'
      >
      <el-form :model="params" :rules="rules" ref="ruleForm">
        <h2>写字楼信息</h2>
        <el-form-item label="城市" prop="city">
          <el-input v-model="params.city" placeholder="（必填）请输入所在城市"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="params.address" placeholder="（必填）请填写详细的区、街道、编号"></el-input>
        </el-form-item>
        <el-form-item label="占地面积" prop="area">
          <el-input v-model="params.area" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="（必填）请填写占地面积"></el-input>
        </el-form-item>
        <el-form-item label="房间数量" prop="roomNum">
          <el-input v-model="params.roomNum" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="（必填）请填写房间数量"></el-input>
        </el-form-item>
        <h2>联系方式</h2>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="params.phone" placeholder="（必填）请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="如何称呼" prop="name">
          <el-input v-model="params.name" placeholder="（必填）请输入联系人姓名"></el-input>
        </el-form-item>
        <h2>备注及其他信息</h2>
        <el-form-item label-width="0" prop="remark">
          <el-input v-model="params.remark" type="textarea" placeholder="请输入备注或其他信息"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="" @click="submit">提交</el-button>
    </el-dialog>
    <div class="banner">
      <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/banner@2x.png" alt />
    </div>
    <div class="section first">
      <div class="container">
        <div class="spaceBetween">
          <div class="one" v-for="item,index in first" :key="index">
            <img :src="item.img" alt />
            <h3>{{item.title}}</h3>
            <div class="line"></div>
            <p>{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="section second">
      <h1 class="white">把写字楼交给智鼎云，只需4步</h1>
      <div class="container">
        <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/yzwt@2x.png" alt class="titleImg" />
        <div class="top box">
          <div class="item" v-for="item,index in second" :key="index">
            <div class="cutline">
              <div class="xian"></div>
              <img class="img1" :src="item.number" alt />
              <div class="xian"></div>
            </div>
            <img class="img2" :src="item.img" alt />
            <h3>{{item.title}}</h3>
            <p>{{item.text}}</p>
          </div>
        </div>
        <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/zhendonhez@2x.png" alt class="titleImg" />
        <div class="middle box">
          <div class="flex flex-column flexCenter">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second5.png" alt />
            <h3>委托管理</h3>
            <p>将整栋或整层房屋资产委托给智鼎云，借助智鼎云平台优势高效运营，风险共担。平台收费低，业主收益高，入住率低于70%不收管理费。</p>
          </div>
          <div class="flex flex-column flexCenter">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second6.png" alt />
            <h3>租赁直营</h3>
            <p>将整栋或整层房屋资产长期出租给智鼎云，智鼎云进行整体规划与运营管理，提升物业价值。定时打款，省心省时带来稳定收益。</p>
          </div>
        </div>
        <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/lxwm@2x.png" alt class="titleImg" />
        <div class="bottom box">
          <div class="spaceBetween">
            <div class="card card1">
              <h3>咨询电话</h3>
              <div class="line"></div>
              <h2>4000-989-222</h2>
              <p>欢迎致电咨询,每天9:00-21:00</p>
            </div>
            <div class="card card2">
              <h3>智鼎云公众号</h3>
              <div class="line"></div>
              <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/gongzh@2x.png" alt />
            </div>
          </div>
          <p class="zhuanye">智鼎云管家提供专业咨询、准确报价</p>
          <div class="btn" @click="dialogVisible=true">有房出租，立即委托</div>
        </div>
      </div>
    </div>
    <div class="section third">
      <div class="container">
        <h2>「 服务团队 」</h2>
        <div class="three spaceBetween">
          <div class="item" v-for="item,index in third" :key="index">
            <img class="background" :src="item.img" alt="">
            <div class="content">
              <div class="con">
                <h3>{{item.title}}</h3>
                <div class="line"></div>
                <p>{{item.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section fourth">
      <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/beijin4.png" alt="">
    </div>
    <div class="section fifth">
      <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/beijin5.png" alt="">
    </div>
  </div>
</template>

<script>
import { trustSubmit } from '@/api/common.js'
export default {
  name: "",
  components: {},
  data() {
    return {
      rules:{
        city: [
          { required: true, message: '请输入城市名称', trigger: 'blur' },
        ],
        address:[
          {required: true, message: '请输入地址', trigger: 'blur'}
        ],
        area:[
          {required: true, message: '请输入面积数值', trigger: 'blur'}
        ],
        roomNum:[
          {required: true, message: '请输入房间数量', trigger: 'blur'}
        ],
        phone:[
          {required: true, message: '请输入联系人号码', trigger: 'blur'},
          {
            pattern: /^1[1-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ],
        name:[
          {required: true, message: '请输入联系人姓名', trigger: 'blur'}
        ],
      },
      params:{
        city:'',
        address:'',
        area:'',
        roomNum:'',
        phone:'',
        name:'',
        remark:''
      },
      dialogVisible:false,
      first:[
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/first1.png",title: "品牌信赖",text: "知名大品牌，值得信赖" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/first2.png",title: "收益更稳健",text: "房租定时打款，拥有强大的房屋出租能力，不用担心房屋空置" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/first3.png",title: "房屋有保护",text: "专属管家代办租务，定制智能门锁电表，解决后顾之忧" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/first4.png",title: "租客有保证",text: "严格筛选优质租客，建立租客信用档案，减少不良租住行为" },
      ],
      second:[
        { number:"https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/1.png",img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second1.png",title: "提交委托信息",text: "提交基本信息在线委托，或直接拨打委托热线" },
        { number:"https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/2.png",img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second2.png",title: "与管家沟通",text: "业主服务中心30分钟内给您回电，指派专属管家" },
        { number:"https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/3.png",img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second3.png",title: "制定出租方案",text: "智鼎云管家上门实勘报价，制定出租委托方案" },
        { number:"https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/4.png",img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/second4.png",title: "成为智鼎云业主",text: "签署出租委托协议，尊享智鼎云资产管理服务" },
      ],
      third:[
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/third1.png",title: "管家",text: "为您提供资产管理服务" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/third2.png",title: "配置",text: "为您提供房屋装修及配置服务" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/third3.png",title: "保洁",text: "为您提供房屋双周保洁服务" },
        { img: "https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/third4.png",title: "维修",text: "专业维修师傅2小时内线条响应" },
      ],

    };
  },
  methods: {
    init() {},
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let data=Object.assign({},this.params);
          trustSubmit(data).then(res=>{
            if(res.status==0){
              this.$message.success('委托已提交')
              this.dialogVisible=false
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    }
  },
  computed:{
    isMobile(){
      console.log(this.$store.getters.scale,"大小")
      if(this.$store.getters.scale>480){
        return '30%'
      }else{
        return '90%'
      }
    }
  },
  created() {
    this.init(
     
    );
  }
};
</script>

<style lang='less' scoped>
@import "~style/index";
@import "~style/media";
.line {
  width: 40px;
  height: 2px;
  background: rgba(255, 122, 50, 1);
  margin: 20px 0;
}
.dialog{
  /deep/ .el-button--primary{
    color: #ffffff;
    background: #fd7e25;
    border-color: #fd7e25;
    width: 50%;
    position: relative;
    transform: translateX(-50%);
    left:50%;
  }
}
.trust {
  .banner {
    width: 100%;
    img {
      display: block;
    }
  }
  .section {
    width: 100%;
    .container {
      max-width: 1200px;
      margin: 0 auto;
    }
  }
  .first {
    padding: 80px 0;
    background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/beijin1@2x.png") left top no-repeat;
    background-size: cover;
    .one {
      flex: 0 0 20%;
      background: #ebecf4;
      padding: 30px 15px;
      // height: 330px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border:1px solid transparent;
      img {
        width: 90px;
      }
      h3 {
        font-size: 18px;
        margin-top: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      p {
        text-align: center;
      }
    }
    .one:hover{
      transform: scale(1.1);
      border:1px solid #ff7a32
    }
  }
}
.second {
  background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/beijin2@2x.png") left top no-repeat;
  background-size: cover;
  padding-top: 80px;
  h1 {
    margin-bottom: 80px;
    text-align: center;
    font-size: 60px;
  }
  .container {
    background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/baik@2x.png") left top no-repeat;
    background-size: 100% 100%;
    padding: 80px;
    box-sizing: border-box;
    .titleImg {
      width: 100%;
    }
    .box {
      padding: 50px 0;
    }
    .top {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .cutline {
          width: 100%;
          display: flex;
          align-items: center;
          .xian {
            display: block;
            background: #dcbc93;
            flex: 1;
            height: 2px;
          }
          .img1 {
            flex: 0 0 38px;
            width: 38px;
            height: 38px;
          }
        }
        .img2 {
          width: auto;
          height: 55px;
          margin: 20px 0;
        }
        h3 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
        }
        p {
          width: 80%;
          font-size: 16px;
          text-align: center;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .middle {
      display: flex;
      .flex {
        img {
          height: 54px;
          width: auto;
        }
        h3 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
          margin: 20px 0;
        }
        p {
          text-align: center;
          width: 80%;
          font-size: 16px;
          line-height: 44px;
          font-weight: 400;
        }
      }
      .flex:first-child {
        border-right: 1px solid #dcbc93;
      }
    }
  }
  .bottom {
    padding-bottom: 0 !important;
    .card {
      background-size: 100%;
      flex: 0 0 47%;
      padding: 32px 60px;
      box-sizing: border-box;
      border-radius: 6px;
      overflow: hidden;
      h3 {
        font-size: 24px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .line {
        width: 100%;
        height: 1px;
        margin: 20px 0;
        background: #333333;
      }
      h2 {
        font-size: 34px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      p {
        font-size: 16px;
      }
    }
    .card1 {
      background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/zxdh@2x.png") no-repeat left top;
    }
    .card2 {
      background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/zdygzh@2x.png") no-repeat left top;
      img {
        width: 122px;
      }
    }
    .zhuanye {
      font-size: 28px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin: 50px 0 30px 0;
      text-align: center;
    }
    .btn {
      width: 50%;
      height: 90px;
      background: rgba(255, 122, 50, 1);
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      font-size: 34px;
      color: white;
      line-height: 90px;
      text-align: center;
      cursor: pointer;
    }
    .btn:hover{
      transform:translateX(-50%) scale(1.1);
    }
  }
}
.third{
  padding:80px 0;
  background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/beijin3@2x.png") left top no-repeat;
  background-size: cover;
  .container{
    padding:0 80px;
    box-sizing: border-box;
  }
  h2{
    font-size:34px;
    margin-bottom: 78px;
    font-weight:bold;
    text-align: center;
    color:rgba(51,51,51,1);
  }
  .three{
    flex-wrap: wrap;
    .item{
      flex:0 0 45%;
      height: 250px;
      margin-bottom:20px;
      position: relative;
      .background{
        width:100%;
        height:100%;
        position: absolute;
        z-index:0;
        object-fit: cover;
      }
      .content{
        display: flex;
        justify-content: flex-end;
        position: relative;
        z-index:5;
        .con{
          padding-top:20px;
          padding-right:20px;
          width: 50%;
          box-sizing: border-box;
        }
        h3{
          font-size:34px;
          font-weight:bold;
          color:rgba(255,255,255,1);
        }
        .line{
          height: 2px;
          background: #fff;
          width: 100%;
        }
        p{
          font-size:18px;
          margin-top:10px;
          color:white;
        }
      }
    }
  }
}
.fourth,.fifth{
  img{
    display: block
  }
}
</style>